import React, { useState } from "react";
import { StyleSheet, View, Pressable, StyleProp, ViewStyle } from "react-native";
import CustomText from "../../common/general/CustomText/CustomText";
import { useAppConfig } from "../../../AppConfigProvider";

interface TabData {
  key: string;
  title: string;
}

interface CourseTabNavigatorProps {
  tabData: TabData[];
  activeTab: string;
  onTabPress: (tabKey: string) => void;
}

const CourseTabNavigator: React.FC<CourseTabNavigatorProps> = ({ tabData, activeTab, onTabPress }) => {
  const [hoveredTab, setHoveredTab] = useState<string | null>(null);
  const appConfig = useAppConfig();
  const activeTabColor = appConfig.primaryColor;

  return (
    <View style={styles.navBar}>
      {tabData.map((tab) => {
        const isActive = activeTab === tab.key;
        const isHovered = hoveredTab === tab.key;

        return (
          <Pressable
            key={tab.key}
            style={[styles.tab, isActive && [styles.activeTab, isHovered && { borderColor: activeTabColor }]]}
            onPress={() => onTabPress(tab.key)}
            onHoverIn={() => setHoveredTab(tab.key)}
            onHoverOut={() => setHoveredTab(null)}>
            <CustomText
              text={tab.title}
              size="s"
              weight={isActive ? "bold" : "medium"}
              style={[
                styles.tabText,
                isActive
                  ? [styles.activeTabText, { color: activeTabColor }]
                  : [styles.inactiveTabText, isHovered && styles.hoveredTabText],
              ]}
            />
          </Pressable>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  navBar: {
    flexDirection: "row",
    backgroundColor: "#F9FAFB",
    padding: 8,
    gap: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
  },
  tab: {
    paddingHorizontal: 20,
    paddingVertical: 12,
  },
  activeTab: {
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#E5E7EB",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 2,
  },
  tabText: {
    fontSize: 14,
    fontWeight: "500",
  },
  activeTabText: {
    fontWeight: "600",
  },
  inactiveTabText: {
    color: "#6B7280",
  },
  hoveredTabText: {
    color: "#1E293B",
  },
});

export default CourseTabNavigator;
